"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.generateTitle = void 0;

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var generateTitle = function generateTitle(title, children) {
  var acceptedTypes = ['number', 'string'];
  var isValidType = acceptedTypes.includes(_typeof(children));
  return title || (isValidType ? children : null);
};

exports.generateTitle = generateTitle;
var _default = generateTitle;
exports.default = _default;